import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  fetchEligibilityRules,
  fetchPatientOutreachCounts,
  fetchPatientOutreachFilterOptions
} from "actions/patient-outreaches";
import TotalCountsHeader from "./total-counts-header";
import PoolRules from "./pool-rules";
import FilterBar from "./filter-bar";
import Grid from "./grid";
import PatientLookupPanel from "./patient-lookup-panel";
import "./patient-outreaches.scss";

const PatientOutreaches = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchPatientOutreachCounts());
    dispatch(fetchEligibilityRules());
    dispatch(fetchPatientOutreachFilterOptions());
  }, [dispatch]);

  return (
    <div className="patient-outreaches-page">
      <h1>Patient Call Pool</h1>
      <TotalCountsHeader />
      <PatientLookupPanel />
      <PoolRules />
      <FilterBar />
      <Grid />
    </div>
  );
};

export default PatientOutreaches;
